export const getTipContent = (tip, age) => {
  switch (tip) {
    case "Development":
      let res = [];
      if (age === "A") {
        res = {
          Ask: (
            <div className="red">
              The baby can focus on objects and preferentially looks at mother’s
              face; Moves all 4 limbs
            </div>
          ),
          Do: "N/A",
          Assess:
            "Any dysmorphism? ; Any congenital anomaly? ; Tone abnormality? ",
          Counsel: "N/A",
        };
      } else if (age === "B") {
        res = {
          Ask: "Holding head steady?; Trying to reach out?; Interested in surroundings?; Making sounds?",
          Do: "TDSC Screening",
          Assess:
            "Head control; Hand regard; Reach out; Vocalization; Visual tracking",
          Counsel: "N/A",
        };
      } else if (age === "C") {
        res = {
          Ask: "Rolling over; Sitting with support; Playing with large objects: hand to hand, hand to mouth, banging etc.; Imitates facial Expressions; Reciprocates smile and laugh; Enjoys mirror;  Babbling ",
          Do: "TDSC Screening",
          Assess: "N/A",
          Counsel: "N/A",
        };
      } else if (age === "D") {
        res = {
          Ask: "Can sit up and crawl; Reaches out for small objects; Can manipulate toys; Starts to imitate; Shows preference and emotions; Separation anxiety; Few bi-syllables",
          Do: "TDSC screening",
          Assess: "N/A",
          Counsel: "N/A",
        };
      } else if (age === "E") {
        res = {
          Ask: "Can stand alone; Mature pincer grasp; Handles spoon; Hugs doll; Indicates needs; Few words with meaning",
          Do: "TDSC screening",
          Assess: "N/A",
          Counsel: "N/A",
        };
      } else if (age === "F") {
        res = {
          Ask: "Can walk; Enjoys picture books, flips pages; Enjoys scribbling; Stacks 2-3 blocks; Feeds doll; Indicates needs; Few words with meaning",
          Do: "TDSC screening",
          Assess: "N/A",
          Counsel: "N/A",
        };
      } else if (age === "G") {
        res = {
          Ask: "Can run stiffly; Loves to crumble, scribble, colour and tear; Enjoys picture books, flips pages; Enjoys scribbling/ colouring; Stacks 4-5 blocks; Feeds doll, mimics cooking; Names and identifies common objects; Talks in short sentences; Explores the surroundings",
          Do: "TDSC screening, MCHAT",
          Assess: "N/A",
          Counsel: "N/A",
        };
      } else if (age === "H") {
        res = {
          Ask: "Can run well and climb up stairs; Enjoys picture books, flips pages; Enjoys scribbling/ colouring; Stacks 4-5 blocks; Feeds doll, mimics cooking; Names and identifies common objects; Knows shapes and colours- can match; Talks in short sentences; Explores the surroundings; Handedness  established by the 3rd year",
          Do: "TDSC screening ; MCHAT (if not done at 24 months)",
          Assess: "N/A",
          Counsel: "N/A",
        };
      } else if (age === "I") {
        res = {
          Ask: "Can run well and climb up stairs; Can throw, catch, and kick balls, ride on tricycles, climb & dance; Enjoys picture books, flips pages; Enjoys colouring; Can draw a horizontal line; Can imitate circle and cross; Stacks 4-5 blocks; Feeds doll, mimics cooking; Names and identifies common objects; Knows shapes and colours- can match; Enjoys jigsaw puzzles, building blocks and cause-and-effect toys; Talks in short sentences; Explores the surroundings",
          Do: "TDSC screening",
          Assess: "N/A",
          Counsel: "N/A",
        };
      } else if (age === "J") {
        res = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      } else if (age === "K") {
        res = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      } else if (age === "L") {
        res = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      }
      return res;

    case "GoodHealth":
      let goodHealthRes = [];
      if (age === "A") {
        goodHealthRes = {
          Ask: "Health concern; Urine & stool; Maternal health",
          Do: "Immunization",
          Assess: "Vision screen; OAE; Neonatal screen",
          Counsel: "Danger signs; Mother mental health care",
        };
      } else if (age === "B") {
        goodHealthRes = {
          Ask: "Health; Vision; Hearing",
          Do: "Immunization",
          Assess: "Vision screen (if not done earlier)",
          Counsel: "Healthy home environment; Maternal mental health",
        };
      } else if (age === "C") {
        goodHealthRes = {
          Ask: "Health; Vision; Hearing",
          Do: "Immunization",
          Assess: "Pallor; Vision & Hearing screen; Vitamin D prophylaxis?",
          Counsel: "Healthy home environment; Maternal mental health",
        };
      } else if (age === "D") {
        goodHealthRes = {
          Ask: "Health; Vision; Hearing",
          Do: "Immunization",
          Assess: "Pallor; Rickets; VitaminD prophylaxis?; Dental check up",
          Counsel: "Healthy home environment; Maternal mental health",
        };
      } else if (age === "E") {
        goodHealthRes = {
          Ask: "Health; Vision; Hearing",
          Do: "Immunization",
          Assess: "Pallor; Rickets; VitaminD prophylaxis?; Dental check up",
          Counsel: "Healthy home environment; Maternal mental health",
        };
      } else if (age === "F") {
        goodHealthRes = {
          Ask: "Health; Vision; Hearing",
          Do: "Immunization",
          Assess: "Pallor; Rickets; VitaminD prophylaxis?; Dental check up",
          Counsel: "Healthy home environment",
        };
      } else if (age === "G") {
        goodHealthRes = {
          Ask: "Health; Vision; Hearing",
          Do: "Immunization",
          Assess: "Pallor; Rickets; VitaminD prophylaxis?; Dental check up",
          Counsel: "Healthy home environment",
        };
      } else if (age === "H") {
        goodHealthRes = {
          Ask: "Health; Vision; Hearing",
          Do: "Immunization",
          Assess: "Pallor; Rickets; VitaminD prophylaxis?; Dental check up",
          Counsel: "Healthy home environment",
        };
      } else if (age === "I") {
        goodHealthRes = {
          Ask: "Health; Vision; Hearing",
          Do: "Immunization",
          Assess: "Pallor; Rickets; VitaminD prophylaxis?; Dental check up",
          Counsel: "Healthy home environment",
        };
      } else if (age === "J") {
        goodHealthRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      } else if (age === "K") {
        goodHealthRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      } else if (age === "L") {
        goodHealthRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      }
      return goodHealthRes;

    case "Nutrition":
      let nutRes = [];
      if (age === "A") {
        nutRes = {
          Ask: "Is baby feeding on breast?",
          Do: "Anthropometry",
          Assess: "Feeding technique",
          Counsel: "Exclusive breast feeding; Hygiene; Not enough milk",
        };
      } else if (age === "B") {
        nutRes = {
          Ask: "Is baby feeding on breast?",
          Do: "Anthropometry",
          Assess: "Feeding technique",
          Counsel: "Exclusive breast feeding; Hygiene; Not enough milk",
        };
      } else if (age === "C") {
        nutRes = {
          Ask: "Complimentary feeding started?",
          Do: "Anthropometry",
          Assess: "Feeding plan",
          Counsel:
            "Complimentary feeds: what, When, how and how much?; Promote Responsive feeding",
        };
      } else if (age === "D") {
        nutRes = {
          Ask: "Complimentary feeding; Continuing breast feeding?",
          Do: "Anthropometry",
          Assess: "Feeding plan",
          Counsel:
            "Complimentary feeds: what, when, how and how much?; Encourage self feeding; Promote Responsive feeding",
        };
      } else if (age === "E") {
        nutRes = {
          Ask: "Number of meals?; Variety in food item, taste and texture?",
          Do: "Anthropometry",
          Assess: "Feeding plan",
          Counsel:
            "Complimentary feeds: what, when, how and how much?; Encourage self feeding; Promote Responsive feeding; Feed child from family pot; No screen time during meals; No forced feeding",
        };
      } else if (age === "F") {
        nutRes = {
          Ask: "Mixed diet?; Number of meals?; Variety?; All textures?; Self feeding?",
          Do: "Anthropometry",
          Assess: "Feeding plan",
          Counsel:
            "Complimentary feeds: what, when, how and how much?; Encourage self feeding; Promote Responsive feeding; Feed child from family pot",
        };
      } else if (age === "G") {
        nutRes = {
          Ask: "Number of meals?; Variety?; All textures?; Self feeding?",
          Do: "Anthropometry",
          Assess:
            "Feeding plan; Ensure all 7 food groups are included over the days meal",
          Counsel:
            "3 meals+2 snacks/day; Encourage self feeding; Promote Responsive feeding; Child eats from his own plate, at the table with the family; No forced feeding; No screen time during meals",
        };
      } else if (age === "H") {
        nutRes = {
          Ask: "Number of meals?; Variety?; All textures?; Self feeding?",
          Do: "Anthropometry",
          Assess:
            "Feeding plan; Ensure all 7 food groups are included over the days meal",
          Counsel:
            "3 meals+2 snacks/day; Encourage self feeding; Promote Responsive feeding; Child eats from his own plate, at the table with the family; No forced feeding ; No screen-time during meals; Breastfeeding to continue till 2 years",
        };
      } else if (age === "I") {
        nutRes = {
          Ask: "Number of meals?; Variety?; All textures?; Self feeding?",
          Do: "Anthropometry",
          Assess: "Feeding plan",
          Counsel:
            "3 meals+2 snacks/day; Encourage self feeding; Promote Responsive feedings; Child eats from his own plate, at the table with the family; No forced feeding; No screen time during meals",
        };
      } else if (age === "J") {
        nutRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      } else if (age === "K") {
        nutRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      } else if (age === "L") {
        nutRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      }
      return nutRes;

    case "Security-Safety":
      let securityRes = [];
      if (age === "A") {
        securityRes = {
          Ask: "Baby proofing in bed/crib",
          Do: "N/A",
          Assess: "Signs of neglect",
          Counsel: "Choking hazard; No smoking",
        };
      } else if (age === "B") {
        securityRes = {
          Ask: "Child proofing ",
          Do: "N/A",
          Assess: "Signs of neglect",
          Counsel: "Prevent fall, burns, smothering, choking etc; No smoking",
        };
      } else if (age === "C") {
        securityRes = {
          Ask: "Child proofing",
          Do: "N/A",
          Assess: "Signs of neglect",
          Counsel:
            "Prevent fall, burns, drowning, smothering, choking; No smoking",
        };
      } else if (age === "D") {
        securityRes = {
          Ask: "Child proofing ; Safe toys",
          Do: "N/A",
          Assess: "Signs of physical or emotional abuse/neglects",
          Counsel:
            "Prevent fall, burns, drowning, smothering, choking etc; No smoking; Prevent physical/ emotional abuse",
        };
      } else if (age === "E") {
        securityRes = {
          Ask: "Child proofing ; Safe toys; Supervised play",
          Do: "N/A",
          Assess: "Signs of physical or emotional abuse/neglects",
          Counsel:
            "Prevent fall, burns, drowning, smothering, choking etc; No smoking; Do not leave baby alone with small toys/sharp objects etc; Prevent physical/ emotional abuse/neglect",
        };
      } else if (age === "F") {
        securityRes = {
          Ask: "Child proofing; Safe toys",
          Do: "N/A",
          Assess: "Signs of physical or emotional abuse/neglect",
          Counsel:
            "Prevent fall, burns, drowning, smothering, choking etc; No smoking; Prevent physical/ emotional abuse",
        };
      } else if (age === "G") {
        securityRes = {
          Ask: "Child proofing; Safe toys; Safety issues at Home & surroundings?",
          Do: "N/A",
          Assess: "Signs of physical or emotional abuse/neglect",
          Counsel:
            "Prevent fall, burns, drowning, smothering, accidents etc; No smoking; Prevent physical/ emotional abuse",
        };
      } else if (age === "H") {
        securityRes = {
          Ask: "Child proofing; Safe toys; Safety issues at Home & surroundings?; Supervision?",
          Do: "N/A",
          Assess: "Signs of physical or emotional abuse/neglect",
          Counsel:
            "Prevent fall, burns, drowning, smothering, accidents etc; No smoking; Prevent physical/ emotional abuse",
        };
      } else if (age === "I") {
        securityRes = {
          Ask: "Child proofing; Safe toys; Safety issues at Home & surroundings?",
          Do: "N/A",
          Assess: "Signs of physical or emotional abuse/neglect",
          Counsel:
            "Prevent fall, burns, drowning, smothering, accidents etc; No smoking; Prevent physical/emotional abuse",
        };
      } else if (age === "J") {
        securityRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      } else if (age === "K") {
        securityRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      } else if (age === "L") {
        securityRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      }
      return securityRes;

    case "Responsive-Caregiving":
      let careRes = [];
      if (age === "A") {
        careRes = {
          Ask: "N/A",
          Do: "N/A",
          Assess: "Parental concern about baby",
          Counsel:
            "Skin-to-skin contact; How to handle the baby with affection and care",
        };
      } else if (age === "B") {
        careRes = {
          Ask: "How parents interact with Baby; How they comfort Baby; Do they talk with baby?",
          Do: "N/A",
          Assess: "Parental engagement with baby",
          Counsel: "Respond to the baby cues consistently and effectively",
        };
      } else if (age === "C") {
        careRes = {
          Ask: "How parents interact with Baby; How they comfort Baby?; Do they talk with baby?",
          Do: "N/A",
          Assess: "Parental engagement with baby",
          Counsel: "Respond to the baby cues consistently and effectively",
        };
      } else if (age === "D") {
        careRes = {
          Ask: "How parents interact with Baby; Do they talk with baby?",
          Do: "N/A",
          Assess: "Parental engagement with baby; Joint attention",
          Counsel:
            "Respond to the baby cues consistently and effectively; Pay attention to his emotions and respond accordingly",
        };
      } else if (age === "E") {
        careRes = {
          Ask: "How parents interact with Baby; Do they talk with baby?; Any concern about behaviour?; Sleep hygiene; Screen time?",
          Do: "N/A",
          Assess: "Parental engagement with baby; Joint attention",
          Counsel:
            "Respond to the baby cues consistently and effectively; Pay attention to his emotions and respond accordingly; Tips on positive parenting",
        };
      } else if (age === "F") {
        careRes = {
          Ask: "How parents interact with Baby? Do they talk with baby?; Any concern about behaviour?; Sleep hygiene; Screen time?",
          Do: "N/A",
          Assess: "Parental engagement with baby, Joint attention",
          Counsel:
            "Respond to the baby cues consistently and effectively.; Pay attention to his emotions and respond accordingly; Tips on positive parenting; How to address unwanted behaviour",
        };
      } else if (age === "G") {
        careRes = {
          Ask: "How parents interact with Baby? Do they talk with baby?; Any concern about behaviour?; Sleep hygiene; Screen time?;Toilet training",
          Do: "N/A",
          Assess: "Parental engagement with baby, Joint attention",
          Counsel:
            "Respond to the baby cues consistently and effectively.; Pay attention to his emotions and respond accordingly; Tips on positive parenting; How to address unwanted behaviour",
        };
      } else if (age === "H") {
        careRes = {
          Ask: "How parents interact with Baby? Do they talk with baby?; Any concern about behaviour?; Sleep hygiene; Screen time?;Toilet training",
          Do: "N/A",
          Assess: "Parental engagement with baby, Joint attention",
          Counsel:
            "Respond to the baby cues consistently and effectively.; Pay attention to his emotions and respond accordingly; Tips on positive parenting; How to address unwanted behaviour",
        };
      } else if (age === "I") {
        careRes = {
          Ask: "How parents interact with Baby? Do they talk with baby?; Any concern about behaviour?; Sleep hygiene; Screen time?;Toilet training",
          Do: "N/A",
          Assess: "Parental engagement with baby, Joint attention",
          Counsel:
            "Respond to the baby cues consistently and effectively.; Pay attention to his emotions and respond accordingly; Tips on positive parenting; How to address unwanted behaviour",
        };
      } else if (age === "J") {
        careRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      } else if (age === "K") {
        careRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      } else if (age === "L") {
        careRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      }
      return careRes;

    case "Oppertunity-for-Early-Learning":
      let learningRes = [];
      if (age === "A") {
        learningRes = {
          Ask: "N/A",
          Do: "N/A",
          Assess: "Parental involvement",
          Counsel:
            "Smile at, sing to baby; Hold baby in your arms, caress, stroke, gentle massage; Bright, colourful curtains, bed linen; Allow baby to move all 4 limbs freely",
        };
      } else if (age === "B") {
        learningRes = {
          Ask: "N/A",
          Do: "N/A",
          Assess: "Parental involvement",
          Counsel:
            "Smile at, sing to and talk with the baby. Make funny faces ; Bright, colourful curtains, bed linen; Hang colourful toys above crib; Shake a rattle; Allow baby to move all 4 limbs freely",
        };
      } else if (age === "C") {
        learningRes = {
          Ask: "Both parents playing with the baby?",
          Do: "N/A",
          Assess: "Parental involvement",
          Counsel:
            "Smile at, sing to and talk with the baby. Make funny faces ; Offer safe, large toys for handling; Play with baby; Expose to different textures",
        };
      } else if (age === "D") {
        learningRes = {
          Ask: "Both parents playing with the baby?",
          Do: "N/A",
          Assess: "Parental involvement",
          Counsel:
            "Play Peekaboo; Imitation of actions like waving, clapping; Show pictures in a picture book; Teach baby names of common objects; Give baby safe simple toys of various colours, shapes and textures",
        };
      } else if (age === "E") {
        learningRes = {
          Ask: "Both parents playing with the baby?",
          Do: "N/A",
          Assess: "Parental involvement",
          Counsel:
            "Allow free movement; Stacking, nesting of objects; Putting small objects in container and dumping out; Poking with one finger; Initiate imitation and pretend play with doll; Talk meaningfully with child in small sentences.; Name common objects",
        };
      } else if (age === "F") {
        learningRes = {
          Ask: "Both parents playing with the baby?",
          Do: "N/A",
          Assess: "Parental involvement",
          Counsel:
            "Allow free movement; Manipulative play (unscrewing/ fitting/ pulling/pushing etc); Scribbling; Initiate imitation and pretend play with doll; Play with colours/water/sand etc (supervised); Talk meaningfully with child in small sentences.",
        };
      } else if (age === "G") {
        learningRes = {
          Ask: "Both parents playing with the baby?",
          Do: "N/A",
          Assess: "Parental involvement",
          Counsel:
            "Stimulate child’s curiosity; Manipulative play (unscrewing/ fitting/ pulling/pushing etc); Problem solving play; Pretend play ; Play with colours/water/sand etc (supervised);Promote scribbling and other pre-writing skills; Talk meaningfully with child in small sentences;Read together; Work on school readiness",
        };
      } else if (age === "H") {
        learningRes = {
          Ask: "Both parents playing with the baby?",
          Do: "N/A",
          Assess: "Parental involvement",
          Counsel:
            "Play outdoors with child to promote physical activities; Encourage interaction with other children; Stimulate child’s curiosity: answer questions; Help him name  and describe things, count object; Tell stories; Sing and tell rhymes; Problem solving games;  Pretend play ; Play with colours/water/sand etc (supervised); Promote pre-writing skills; Talk meaningfully with child in small sentences;  Read together; Work on school readiness",
        };
      } else if (age === "I") {
        learningRes = {
          Ask: "Both parents playing with the baby?",
          Do: "N/A",
          Assess: "Parental involvement",
          Counsel:
            "Play outdoors with child to promote physical activities; Encourage interaction with other children; Stimulate child’s curiosity: answer questions; Help him name  and describe things, count object; Tell stories; Sing and tell rhymes; Problem solving games; Pretend play ; Play with colours/water/sand etc (supervised); Promote self-help and ADL; Promote pre-writing skills; Talk meaningfully with child in small sentences; Read together; Work on school readiness",
        };
      } else if (age === "J") {
        learningRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      } else if (age === "K") {
        learningRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      } else if (age === "L") {
        learningRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      }
      return learningRes;

    case "Red-Flags":
      let flagsRes = [];
      if (age === "A") {
        flagsRes = {
          Ask: "N/A",
          Do: "N/A",
          Assess:
            "Not looking at caregivers face; Not turning to sound; Asymmetric face or limbs; Tone abnormality",
          Counsel: "N/A",
        };
      } else if (age === "B") {
        flagsRes = {
          Ask: "N/A",
          Do: "N/A",
          Assess:
            "No social smile; Does not look at caregiver when handled or fed; Does not look at hanging toys; Squint; Not turning to sound; Tone abnormality; Asymmetric body movement; Constant fisting of hand",
          Counsel: "N/A",
        };
      } else if (age === "C") {
        flagsRes = {
          Ask: "N/A",
          Do: "N/A",
          Assess:
            "Head lag; Not reaching out towards object; Not following object with eyes; Not sitting with support; No vocalization",
          Counsel: "N/A",
        };
      } else if (age === "D") {
        flagsRes = {
          Ask: "N/A",
          Do: "N/A",
          Assess:
            "Cannot turn over; Cannot sit without support; Persistent tonic neck reflex; Does not manipulate toys with hands; Not uttering mono-syllables",
          Counsel: "N/A",
        };
      } else if (age === "E") {
        flagsRes = {
          Ask: "N/A",
          Do: "N/A",
          Assess:
            "Cannot sit up or stand with support; No pincer grasp; Does not respond when called; No words with meaning; Poor social responses like waving bye-bye, stretching arms to be lifted etc; Does not enjoy simple games like peek-a-boo",
          Counsel: "N/A",
        };
      } else if (age === "F") {
        flagsRes = {
          Ask: "N/A",
          Do: "N/A",
          Assess:
            "Cannot walk; Scissoring of lower limbs; Poor object handling; No meaningful play; Poor joint attention; No verbal communication;Doesnt point, wave or use gestures; Does not follow simple commands; Does not enjoy eye contact or cuddles",
          Counsel: "N/A",
        };
      } else if (age === "G") {
        flagsRes = {
          Ask: "N/A",
          Do: "N/A",
          Assess:
            "Does not run or climb stairs; Cannot join 2 words; No pretend play; Poor emotional expression; Does not copy actions; Does not scribble",
          Counsel: "N/A",
        };
      } else if (age === "H") {
        flagsRes = {
          Ask: "N/A",
          Do: "N/A",
          Assess: "N/A",
          Counsel: "N/A",
        };
      } else if (age === "I") {
        flagsRes = {
          Ask: "N/A",
          Do: "N/A",
          Assess:
            "Unable to go up/down stairs; Cannot feed self or help in dressing; No pretend play; No 3-word sentence; Cannot communicate meaningfully; Not responding when called; Does not point at objects",
          Counsel: "N/A",
        };
      } else if (age === "J") {
        flagsRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      } else if (age === "K") {
        flagsRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      } else if (age === "L") {
        flagsRes = {
          Ask: "To be filled",
          Do: "To be filled",
          Assess: "To be filled",
          Counsel: "To be filled",
        };
      }
      return flagsRes;

    default:
      return "";
  }
};
